import type { CarrierPrice } from "~/shared/schemas/carrier-schema";
import { formatCurrency } from "~/shared/utils/string-fns.ts";

import { LiabilityDisplay } from "./liability-display.tsx";

type CarrierRatesHeaderProps = {
	selectedCarrier?: CarrierPrice | null;
};

export const CarrierRatesHeader = ({
	selectedCarrier,
}: CarrierRatesHeaderProps) => {
	if (!selectedCarrier) return null;

	const { carrier, serviceType, transitDays, customerRate } = selectedCarrier;
	const dayWord = transitDays && transitDays > 1 ? "Days" : "Day";
	const transitDaysLabel = transitDays ? `${transitDays} ${dayWord}` : null;

	return (
		<>
			{carrier.displayName ? <div>{carrier.displayName}</div> : null}
			{serviceType ? <div>{serviceType}</div> : null}
			{transitDaysLabel ? <div>{transitDaysLabel}</div> : null}

			<LiabilityDisplay selectedCarrier={selectedCarrier} />

			{customerRate ? (
				<div>
					<strong>Rate:</strong> {formatCurrency(customerRate)}
				</div>
			) : null}
		</>
	);
};
